import { useCallback } from "react";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";

import { localeNumber } from "../../../hooks/formatNumber";
import Loader from "../Loader";
import FetchPaginatedData from "../common/FetchPaginatedData";
import { fetchGoalArchive } from "../../../store/slices/admin/goalArchive";
import Pagination from "../common/Pagination";
import moment from "moment";

export default function GoalsArchiveTable() {
	const dispatch = useDispatch();
	const { id } = useParams() as { id: string };

	const changePage = useCallback((page) => {
		dispatch(fetchGoalArchive(id, page));
	}, [dispatch]);

	return (
		<div className="dashboards__table">
			<div className="table-header">
				<h4>Archive</h4>
				<div className="form-group search" />
			</div>

			<FetchPaginatedData
				action={{ function: fetchGoalArchive, payload: { id: id }}}
				storeKey="goalArchive"
				alwaysReload={true}
				render={(data, isLoading, pagination) => (
					<Loader isLoading={isLoading} customClass={"table-loader"}>
						<table className="table">
							{data.archive && data.archive.length ? (
								<>
									<thead>
										<tr>
											<th>Date</th>
											<th>Target</th>
											<th>Achieved</th>
											<th>Percentage</th>
										</tr>
									</thead>
									<tbody>
										{data.archive.map((item: any, index: number) => (
											<tr key={index}>
												<td>{data.goal.recurrencyType === 'daily' ? moment(item.startDate).format("Do MMM Y") : (moment(item.startDate).format("Do MMM Y hh A") + " - " + moment(item.endDate).format("Do MMM Y hh A"))}</td>
												<td>{data.goal.metricType === "totalReadingTime" ? (Number(Math.round(item.target / 3600 * 10) / 10).toLocaleString() + ' hrs') : item.target.toLocaleString()}</td>
												<td>{data.goal.metricType === "totalReadingTime" ? (Number(Math.round(item.achieved / 3600 * 10) / 10).toLocaleString() + ' hrs') : item.achieved.toLocaleString()}</td>
												<td>{localeNumber((item.achieved / item.target) * 100)}%</td>
											</tr>
										))}
									</tbody>
								</>
							) : (
								<tbody>
									<tr>
										<td>No entries in the archive</td>
									</tr>
								</tbody>
							)}
						</table>

						{!isLoading && pagination?.totalPages > 1 && <Pagination page={pagination.currentPage} total={pagination?.totalPages} setPage={changePage} />}
					</Loader>
			)} />
		</div>
	);
}
